import { AUTH_MEDIATOR_BASE } from './v3';

/**
 * The mediator's own endpoint, outside the library's MEDIATOR_PATHS; the string
 * is mirrored in server/mediator/utils.ts.
 */
const PREFILL_PATH = '/prefill';

export interface RegistrationPrefill {
  /** The verified address of the registration, which Core has not been told. */
  email?: string;
}

const isRegistrationPrefill = (value: unknown): value is RegistrationPrefill => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const { email } = value as { email?: unknown };

  return email === undefined || typeof email === 'string';
};

/**
 * What the mediator held back from the registration for the Welcome step. One
 * call, one answer: the mediator forgets the address as it hands it over. Any
 * miss - nothing held, a refusal, a dead network - is simply no prefill, and
 * the form starts empty as it always could.
 */
export const readRegistrationPrefill = async (): Promise<RegistrationPrefill | undefined> => {
  try {
    const response = await fetch(`${AUTH_MEDIATOR_BASE}${PREFILL_PATH}`, {
      method: 'POST',
      credentials: 'same-origin',
    });

    if (response.status !== 200) {
      return undefined;
    }

    const body: unknown = await response.json();

    return isRegistrationPrefill(body) ? body : undefined;
  } catch {
    return undefined;
  }
};
